import { useBetSlip } from "@/context/BetSlipContext";
import { Plus, Check } from "lucide-react";

// Build a slip leg from a prop object (needs an odd). Returns null if unpriced.
export function betLegFrom(p) {
  if (p == null || p.odd == null) return null;
  return {
    id: `${p.fixture_id}|${p.prop_key}|${p.player}`,
    player: p.player,
    prop: p.prop,
    odd: p.odd,
    prob: p.recent ? p.recent.pct / 100 : null,
    home: p.home,
    away: p.away,
    tournament: p.tournament,
    date: p.date,
  };
}

export default function SlipToggle({ leg }) {
  const { has, toggleLeg } = useBetSlip();
  if (!leg) return null;
  const added = has(leg.id);
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        toggleLeg(leg);
      }}
      data-testid="add-to-slip"
      className={
        "flex items-center gap-1 text-xs font-semibold rounded-full px-2.5 py-1 transition-colors shrink-0 " +
        (added ? "bg-primary text-primary-foreground" : "bg-secondary text-foreground hover:bg-secondary/70")
      }
    >
      {added ? <Check className="h-3 w-3" /> : <Plus className="h-3 w-3" />}
      {added ? "Added" : "Slip"}
    </button>
  );
}
